export const sleep = async (seconds: number) => {
  const ms = seconds * 1000;

  await new Promise((resolve) => setTimeout(resolve, ms));
};
